import { StatusPillContext } from '@providers/StatusPillProvider'
import { useContext } from 'react'

export default function useStatusPill() {
  return useContext(StatusPillContext)
}
